import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MotorQuoteStateService } from '../services/motor-quote-state/motor-quote-state.service';
import { QuoteSteps } from '../models/enums/quote-steps';
@Injectable({
    providedIn: 'root'
})
export class VerifyQuickQuestionsGuard {

    constructor(public router: Router,
        private readonly motorQuoteStateService: MotorQuoteStateService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let requiredStep = route.data['step'] as number;

        return this.isAllowedNavigate(requiredStep);
    }

    // TODO: check requirements and test!
    isAllowedNavigate(requiredStep: number): boolean {
        let currentStep = this.motorQuoteStateService.getCurrentStep();

        if (currentStep > requiredStep &&
            currentStep > QuoteSteps.xsellQuote &&
            requiredStep < QuoteSteps.selectProduct) {
            return false;
        }

        if (currentStep < QuoteSteps.selectProduct && requiredStep == QuoteSteps.selectProduct) {
            return false;
        }
        return true;
    }
}